import { s as d, a as f } from "./subMonths-nbU1oDhB.mjs";
import { c as y } from "./format-plq8pBNY.mjs";
function M(s, t) {
  const {
    years: o = 0,
    months: n = 0,
    weeks: e = 0,
    days: u = 0,
    hours: a = 0,
    minutes: c = 0,
    seconds: r = 0
  } = t, i = d(s, n + o * 12), m = f(i, u + e * 7), b = c + a * 60, h = (r + b * 60) * 1e3;
  return y(s, m.getTime() - h);
}
export {
  M as s
};
